export default [
	"玩彩这些年，要玩就要对自己有信心，感觉对的事情，就应该下定决心坚持做下去。",
	"踏踏实实研究才是最真的圆梦路！",
	"简介：假如，彩迷朋友们都和我一样，每月买彩票上有点稳定小收入，那有多好啊！",
	"轻松玩彩，理性购彩，愉悦心情，陶冶情操。",
	"唯一的爱好就是喜欢研究彩票，希望能通过缩水网平台与更多热爱彩票的彩民一起进步",
	"寄语：每天研究彩票，就想着哪天一觉醒来，发现自己中了1000万",
	"我玩彩倾向于选号方法独特",
	"寄语：购彩当娱乐，祝大家彩运亨通。",
	"我现在基本上靠买彩票奔小康，虽没中大奖，小奖无数，现在最大的愿望就是帮助大家中奖。",
	"本人长期研究各种数字型彩票，不定时斩获大小奖。",
	"在投注当中总结了一些选号分析技巧，感觉还挺有用",
	"彩票有风险，投资需谨慎，望大家能在实践中总结出更多规律，提高自身的投注技术",
	"建立长期实践基础上的选号思路，合理完成投注。",
	"自从第一次买一注后，我就沉迷其中，后来就深入研究，并找到一套适合自己的方法，小奖无数，期待大奖...",
	"买彩票，想要中奖，得找个靠谱的人帮助。",
	"专业的彩票分析资料，彩民可要重点参考呀",
	"彩票行业只能凭实力证明价值。",
	"本人热爱彩票，希望可以和大家一起掏空奖池，赶紧关注我吧！",
	"喜欢研究周二、周四、周日走势图，分析近期冷热号的规律, 结合历史同期对比分析, 围红杀红、围蓝",
	"希望能给买彩票的朋友提供一定的帮助",
	"本人主要是对福彩3D和体彩排列三比较擅长，主攻缩水！彩票有风险！",
	"不要想着暴富，也不要影响自己正常的生活，咱玩这个要的是乐在其中",
	"在多年的玩彩实践中逐渐总结出不少彩票经验",
	"在空闲时间经常研究号码，并从中优化一些投注方案，简单易懂，也很实用",
	"我热爱彩票，请大家支持我！",
	"目标就是要做彩票的冠军，争取有一天圆梦！",
	"众人拾柴火焰高",
	"直致力于彩票研究预测，个人实战求稳",
	"彩票也讲缘分，有的人投入2元就中了大奖，而有的人投入成千上万结果还是与大奖无缘",
	"实战！实战！",
	"常年缩水，有一套很稳定的分析方法和经验，我会尽力让彩民朋友满意。",
	"希望有钱，希望中大奖！",
	"最近除了睡觉，就是研究彩票，希望我们都能实现美梦中的大奖！",
	"每次中了奖后，不管大小，都能让我有一种莫名的快感。",
	"双色球、大乐透各中了一次二等奖，希望彩运再次降临",
	"本人玩彩票保持平常心态，热爱3D、排列三小盘缩水玩法",
	"善于分析总结彩票开奖规律",
	"大小小的奖也中过不少，期望能中个1000万大奖",
	"本人一直玩彩，积累了丰富的投注经验，定期更新一些数据分析资料",
	"彩票，我一直拥有好运，我将继续把好运传递给大家",
	"我经营一家彩票站，平时很喜欢研究各种数字型彩票，胆码推荐被当地彩民作为重要的参考意见",
	"从小痴迷数学，对数字特别敏感，在几年前开始玩彩票",
	"本人多年彩票资深人士，对许多彩种有所研究，会定期发一些推荐，供彩友们参考",
	"心仪福彩，并在定胆方面略有心得",
	"通过对彩票的了解，我认为投注时参考行家建议，选号技巧和走势图表尤为重要，彩友们可加我关注",
	"多年玩彩，努力研彩，目标成为千万获奖者",
	"喜欢研究投注选号公式，应用到实践当中的效果不错，目前略有成绩",
	"人较为关注福彩的一些玩法，偶尔也抽时间研究了其中的一些规律",
	"多年研究彩票，尤其是针对双色球、大乐透很有心得，希望大家多多支持",
	"买彩十余年，研究双色大乐透6年多，特别擅长胆码的分析推荐，有自己独特的缩水方式",
	"相信自己，取人之长。愿将自己的经验共享出来，供广大彩民朋友参考",
	"彩票是没有绝对规律，理解它的原理性，去开拓新的分析路子才为上道",
	"对福彩情有独钟，已经摸索出一套稳定的方法",
	"本人坚持发布双色球、大乐透、福彩3D、排列三等彩种的预测，较为稳定，大家可以放心参考...",
	"在多年的购彩生涯里，我曾命中福彩3D、排列三直选奖多次，尤其擅长把握缩水，从而减少投注注数",
	"万物都是有规律的，要当大赢家！",
	"多次命中奖号，有成就感！",
	"从不打无准备的仗，每次自己研究买号，等待大奖来临。",
	"本人很喜欢玩彩票，也经营着一家体彩站。",
	"希望能用自己的方法和广大彩民共同分享中奖!",
	"本人在彩票多次的预测中，总结出一些非常有效的缩水方法，成功率很高。",
	"对彩当歌，乐在其中",
	"我对开奖号码有着多套详细的分析方法，主要研究定位、缩水，希望可以帮助到大家。",
	"没事的时候研究研究彩票，带来收益的同时也给生活增添了很多乐趣！",
	"多年研彩高手，投注技术不错。",
	"精研玩彩心得，大家共同分享。",
	"本人在研彩方面略有小成，已成功提炼出属于自己的一套风格和思路。",
	"为什么你买的号码经常与开奖结果差一点？关注我的预测，让你与大奖零距离。",
	"我坚持买彩票并进行研究已有9年多，和附近彩民不断切磋，积累了一些实战经验。",
	"彩票是有规律的，所以我研究并乐在其中!",
	"买彩票是我毕生唯一的爱好，无彩不欢，今天借助彩宝贝平台与大家一起研究彩票。",
	"每期发帖，不间断，期待您的关注。",
	"有自己独特的过滤方法，也摸索出几套目前最适合实战好方法，期待您的关注",
	"听说可以发布预测帮助彩民进行选号，所以我来了，希望和大家一起奔小康",
	"自从投入就小奖不断，希望继续努力拿到梦想的奖项",
	"买彩票看成是一种数字游戏，去找它的可以追索规律的依据，以小的投资博得最大的回报",
	"坚持参与，给自己长存一份希望空间，给社会增添一份公益力量，这是福利事业的基本道理。",
	"“为伊消得人憔悴、衣带渐宽终不悔”",
	"专业分析，专业推荐，专业水准",
	"认真研究彩票，优化投注方案，拉近和大奖的距离",
	"专业选手为您支招，不要错过呀！",
	"最擅长抓取彩票里的胆号，从多方面验证，屡创佳绩。",
	"彩票缩水的方法多种多样，具体哪种更实用？需要实践来验证",
	"精选彩票缩水方案，助力彩民朋友赢取大奖",
	"自彩票上市时就开始长期坚持购买，现在经营一家彩票站，生意很红火",
	"彩票无规律，选号有技巧。",
	"缩水准不准，一起来验证",
	"彩票高手，信我者中奖",
	"想把中奖变得更容易，你能相信我吗？",
	"每天跟彩友探讨走势，每次分析出来的号码，就感觉就像中奖号码，说不定哪天真的能上头奖呢？",
	"作为技术型彩民，对工具、走势图的要求颇高，希望缩水网能提供一切我想要的。",
	"能中出双色球、大乐透除了必要的分析研究之外，更需要超好的运气，关注我一定不会让你失望！",
	"玩彩是一种幸运，也是一种娱乐，只要以轻松心态对待买彩，往往就容易中奖，同时也会感到开心快乐",
	"最初在彩站向老彩民讨教经验，交流缩水方法。后来自己看走势投注，成效不错。",
	"一定要有自己的主见！",
	"乐在其中，重在参与，彩票研究多年，最高记录斩获双色球二等奖",
	"差不多买双色球十六年了，大大小小的奖无数",
	"彩龄不长，但双色球期期必购，虽然中的不多但也乐在其中",
	"彩票中奖概率实在太小，但是我已不再把追逐大奖当做唯一的目标，积小奖也是胜利",
	"本人喜欢彩票，并且潜心研究彩票多年，希望和大家一起种大奖",
	"擅长缩水定胆，偶尔中中奖，生活也乐滋滋",
	"彩票资深人士，对数字很敏感，尤其是在双色球定蓝方面有很深的造诣，现与大家一起分享",
	"买彩票中大奖，是我的梦，更是你们的梦，我们一起加油！",
	"玩彩多年，近几年特别钟情双色球大盘玩法，有幸中过二等奖，不小心与头奖檫肩而过",
	"相信“历史是可以复制的”，对双色球、大乐透、福彩3D、排列三一直都在跟踪分析",
	"擅长从开奖号码当中寻找规律，对于缩水和定胆研究颇深。",
	"对彩票兴趣甚浓，研究方法标新立异，喜欢捉冷，擅长看遗漏形态",
	"希望通过自己累积的经验和技巧，推荐最准确的号码给各位彩民。",
	"玩彩多年，会及时更新一些预测分析资料，大家可作参考",
	"对双色球定胆、福彩3d定胆都有自己的方法，状态好的情况下准确率能达到10期中8、9期，希望大家多多关注。",
	"坚持购彩几年，有时机选号，有时研究走势图选号，有时借助过滤工具选号，中过不少小奖",
	"喜欢研究彩票各种形态的走势规律，比如大小，质合，奇偶等等，目前取得了一些成果",
	"彩票成就了许多人的百万梦想，我们也一起加油",
	"研究彩票多年，属于资深玩家，会定期提供分析资料，大家可作参考。",
	"从2007年开始从事彩票研究，特别钟爱双色球和福彩3d，希望我的预测可以给大家带来好运。",
	"相信自己，超越自我。",
	"努力拼搏，战胜自我，挑战极限。",
	"自律自强，奋斗不息，实现梦想指日可待。",
	"如果不坚持，到哪里都是放弃。",
	"梦想照亮前行之路，努力成就未来之我。",
	"勤奋是成功的基石，努力是人生的阶梯。",
	"努力不懈，铸就辉煌。",
	"梦想皆从磨炼后得来。",
	"信念支撑灵魂，奋斗铸就辉煌。",
	"永远不要放弃你的梦想，努力追求，终会实现。",
	"不放弃，不退缩，始终向前。",
	"永远不要放弃，即使你身处逆境，也要坚持下去。只要你坚持努力，就一定能战胜困难",
	"成功往往住在失败的隔壁！",
	"坚持到底就是成功",
	"最困难的时候就是离成功不远了",
	"宁可辛苦一阵子，不可辛苦一辈子",
	"人生最大的喜悦就是都认为你做不到，但是你确实做到了",


]